<div class="header">
    <div class="left">
        <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
    </div>

    <div class="right">
        <span class="user-name" *ngIf="identity">
            {{ identity?.nombres + ' ' + identity?.apellidoP + ' ' + identity?.apellidoM }}
        </span>
        <button mat-button [matMenuTriggerFor]="menu" *ngIf="identity">
            <mat-icon class="icon" matBadgeColor="warn">person</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openPerfil()">
                <mat-icon matBadgeColor="warn">person</mat-icon> Mi perfil
            </button>
            <button mat-menu-item (click)="logout()">
                <mat-icon>exit_to_app</mat-icon> Cerrar Sesi&oacute;n
            </button>
        </mat-menu>
        <button mat-icon-button matTooltip="Servicios" aria-label="Volver al inicio" (click)="back()">
            <mat-icon class="icon">home</mat-icon>
        </button>
    </div>
</div>

<!-- 
<div>
    <img src="/assets/images/bnr3.png" class="bnr1">
</div> -->


<body>
    <div class="container mat_step_container">
      <!--   <div class="row" align="right">
            <button class="btn_danger" mat-button (click)="cerrar_vista()">Salir</button>
        </div> -->
        <div class="container">
            <mat-horizontal-stepper [linear]="isLinear" class="container-stepper" #stepper>
                <mat-step [stepControl]="firstFormGroup">
                    <ng-template matStepLabel>Solicitante</ng-template>

                    <app-solicitante-insp></app-solicitante-insp>



                </mat-step>


                <mat-step [stepControl]="secondFormGroup">
                    <form [formGroup]="secondFormGroup">
                        <ng-template matStepLabel>Dirección</ng-template>
                        <app-direccion-insp></app-direccion-insp>
                    </form>
                </mat-step>

                <mat-step [stepControl]="thirdFormGroup">
                    <ng-template matStepLabel>Ingreso</ng-template>
                    <app-ingresos-insp></app-ingresos-insp>
                </mat-step>

                <mat-step [stepControl]="quarterFormGroup">
                    <ng-template matStepLabel>Archivos</ng-template>

                    <app-documentos-insp></app-documentos-insp>
                </mat-step>


                <mat-step [stepControl]="resumenFormGroup">
                    <ng-template matStepLabel>Resumen</ng-template>
                    <app-resumen-insp></app-resumen-insp>
                </mat-step>

            </mat-horizontal-stepper>

        </div>

    </div>
</body>